import { Component } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { ApiService } from 'app/api.service';

@Component({
  selector: 'app-create-product-edit-dialog',
  templateUrl: './create-product-edit-dialog.component.html',
  styleUrls: ['./create-product-edit-dialog.component.scss']
})
export class CreateProductEditDialogComponent {
  product: any;
  index: number;
  productOptions: any[];
  taxOptions: any[];

  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<CreateProductEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.product = data.product ;
    this.index = data.index;
    this.productOptions = data.productOptions;
    this.taxOptions = data.taxOptions;
  }

  onSave(): void {
    this.dialogRef.close({ product: this.product, index: this.index });
  }

  fetchhsnno(productTypeId: any) {
    this.apiService.gethsnno(productTypeId).subscribe(
      (response) => {
        this.product.hsn_no = response.hsn_no;
        this.product.unit = response.unit_name;
        this.product.ledger_name = response.ledger_name;
        this.product.ledger_id = response.ledger_id;
      },
      
      (error) => {
        console.error('Error fetching HSN number:', error);
      }
    );
  }
}